const calculateCreationMaxHp = (constitution, healthRank, random = Math.random) =>
  (Number(constitution) || 0) + 1 + Math.floor(random() * 10) + 5 * Math.max(0, Number(healthRank) || 0);

module.exports = { calculateCreationMaxHp };
